<template>
  <div id="header">
    <div class="page-header">
      <div class="title">
        <div class="nav">
          <div class="site">
            <a target="_blank" rel="nofollow">
              <img :src="require('@/assets/images/erlangshenLOGO.png')" @click="goHome" style="cursor: pointer;" />
            </a>
          </div>
          <ul>
            <!-- <li>
							<router-link to="/dashboard/endoc">英文OCR</router-link>
						</li> -->
            <!-- class="dropdown" -->
            <li>
              <router-link to="/dashboard/cedoc">
                <i class="el-menu-icon-box el-menu-icon_head_AI_identification_icon"></i>

                AI识别
                <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
              </router-link>
              <!-- <el-dropdown>
                                <span class="el-dropdown-link">
                                    <router-link to="/dashboard/cedoc">
                                        <i class="el-menu-icon-box el-menu-icon_head_AI_identification_icon"></i>

                                        AI识别 <i class="el-icon-arrow-down el-icon--right"></i>
                                    </router-link>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>DIY识别</el-dropdown-item>
                                    <el-dropdown-item>小语种识别</el-dropdown-item>
                                    <el-dropdown-item>集装箱识别</el-dropdown-item>
                                    <el-dropdown-item>票据混贴识别</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->

            </li>
            <!-- <li>
                            <router-link to="/dashboard/defdoc">自定义识别</router-link>
                        </li> -->
            <li v-if="roleState && roleState === 'admin' && userType === '0'">
              <router-link to="/dashboard/field">
                <i class="el-menu-icon-box el-menu-icon_head_field_icon"></i>
                字段管理</router-link>
            </li>
            <li>
              <router-link to="/dashboard/classify">
                <i class="el-menu-icon-box el-menu-icon_head_type_icon"></i>
                单证分类管理</router-link>
            </li>
            <li>
              <router-link to="/dashboard/template">
                <i class="el-menu-icon-box el-menu-icon_head_template_management_icon"></i>
                模板管理</router-link>
            </li>
            <!--   <li v-if="roleState && roleState==='admin'&& userType === '0'">
              <router-link to="/dashboard/dataset">
                <i class="el-menu-icon-box el-menu-icon_head_data_icon"></i>
                标准数据集</router-link>
            </li>-->


            <li>
              <router-link to="/dashboard/templateCommunity">
                <i class="el-menu-icon-box el-menu-icon_head_template_shop_icon"></i>
                模板社区</router-link>
            </li>
            <li>
              <router-link to="/dashboard/model">
                <i style="font-size: 18px;color: #3D7FFF;" class="el-icon-s-promotion"></i>
                专用模型</router-link>
            </li>
            <li>
              <router-link to="/dashboard/api">
                <i style="font-size: 18px;color: #3D7FFF;" class="el-icon-s-order"></i>
                接口文档</router-link>
            </li>
            <li>
              <router-link to="/dashboard/largeModle">
                <i style="font-size: 18px;color: #3D7FFF;" class="el-icon-s-grid"></i>
                大模型识别</router-link>
            </li>
            <!--
            <li>
              <a style="cursor: pointer;" @click="openFn">
                <i style="font-size: 18px;color: #3D7FFF;" class="el-icon-s-grid"></i>
                识别辅助</a>
            </li>
            -->
            <!--            <li style="-webkit-margin-end: auto">-->
            <!--            <router-link to="/dashboard/userHome">-->
            <!--              <i class="el-menu-icon-box el-menu-icon_head_home"></i>-->
            <!--              用户中心</router-link>-->
            <!--            </li>-->
          </ul>
        </div>
        <div class="user">
          <ul>
            <li>
              <el-popover popper-class="loginPopper" width="80" trigger="click">
                <div class="loginContent">
                </div>
                <div class="loginContent">
                  <ul>
                    <!--                    <li>-->
                    <!--                      <div class="exit" @click="exportConfig">导出配置</div>-->
                    <!--                    </li>-->
                    <!-- <li>
                      <div
                        class="exit"
                        @click="ocrConfig"
                      >OCR类型</div>
                    </li> -->
                    <li>
                      <div class="exit" @click="toUser">用户中心</div>
                    </li>
                    <li>
                      <div class="exit" @click="logout">退出登录</div>
                    </li>
                  </ul>
                </div>
                <div slot="reference">
                  <!-- <i class="icon-default"></i> -->
                  <div class="avatar">
                    <img src="@/assets/images/simple_tx.png" width="30" />
                    <!-- <div class="birthday"></div> -->
                    <div class="crown" v-show="isVip"></div>
                  </div>

                  <!-- <img

                    :src="$utils.cdn + '/simple_tx.png'"
                    width="24"
                  /> -->
                  <span class="username">{{ username }}</span>
                </div>
                <!-- <el-button slot="reference"><i class="name">用户名</i></el-button> -->
              </el-popover>
            </li>
            <!-- <li>
                            <router-link to="/dashboard/userHome">
                                <i class="el-menu-icon-box el-menu-icon_head_home" style="width: 20px;"></i>
                                用户中心</router-link>
                        </li> -->
          </ul>
          <!--          <el-popover-->
          <!--            placement="bottom-end"-->
          <!--            popper-class="loginPopper"-->
          <!--            width="80"-->
          <!--            trigger="click"-->
          <!--          >-->
          <!--            <div class="loginContent">-->
          <!--              <ul>-->
          <!--                <li>-->
          <!--                  <div class="exit" @click="exportConfig">导出配置</div>-->
          <!--                </li>-->
          <!--                &lt;!&ndash; <li>-->
          <!--                  <div-->
          <!--                    class="exit"-->
          <!--                    @click="ocrConfig"-->
          <!--                  >OCR类型</div>-->
          <!--                </li> &ndash;&gt;-->
          <!--                <li>-->
          <!--                  <div class="exit" @click="logout">退出登录</div>-->
          <!--                </li>-->
          <!--              </ul>-->
          <!--            </div>-->
          <!--            <div slot="reference">-->
          <!--              &lt;!&ndash; <i class="icon-default"></i> &ndash;&gt;-->
          <!--              <div class="avatar">-->
          <!--                <img src="@/assets/images/simple_tx.png" width="30" />-->
          <!--                &lt;!&ndash; <div class="birthday"></div> &ndash;&gt;-->
          <!--                <div class="crown" v-show="isVip"></div>-->
          <!--              </div>-->

          <!--              &lt;!&ndash; <img-->

          <!--                :src="$utils.cdn + '/simple_tx.png'"-->
          <!--                width="24"-->
          <!--              /> &ndash;&gt;-->
          <!--              <span class="username">{{ username }}</span>-->
          <!--            </div>-->
          <!--            &lt;!&ndash; <el-button slot="reference"><i class="name">用户名</i></el-button> &ndash;&gt;-->

          <!--          </el-popover>-->
        </div>
      </div>
    </div>
    <el-dialog class="filed-config" v-if="configVisible" title="导出配置" top="20px" :visible.sync="configVisible"
      width="50%" @close="configClose" :close-on-click-modal="false" :append-to-body="true">
      <div style="text-align: right; margin-bottom: 10px">
        <el-button type="primary" @click="selectAll('all')">全选</el-button>
        <el-button type="primary" @click="selectAll('cancel')">取消全选</el-button>
      </div>
      <div style="display: flex; justify-content: space-between">
        <div style="width: 48%">
          <el-table stripe highlight-current-row :data="Object.keys(docTypes)" style="width: 100%" height="400"
            @row-click="tableClick" ref="multipleLeftTable" v-loading="tableLeftLoading" size="medium">
            <el-table-column prop="name" label="单证类型">
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 48%">
          <el-table stripe @row-click="toggleSelection" :data="filedData" style="width: 100%" height="400"
            v-loading="tableRightLoading" ref="dataTable">
            <el-table-column width="50" align="center">
              <template slot-scope="scope">
                <el-checkbox @change="selectFn(scope.row)" v-model="scope.row.usedFlag" :true-label="1"
                  :false-label="0"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="dityName" label="导出对应字段">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="footer" style="text-align: right; margin-top: 20px">
        <el-button type="primary" @click="configClose" class="el-button--cancel">取消</el-button>
        <el-button type="primary" @click="confirmDialog()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog class="filed-config ocr-sty" v-if="ocrVisible" title="OCR类型配置" :visible.sync="ocrVisible" width="50%"
      @close="ocrConfigClose" :close-on-click-modal="false" :append-to-body="true">
      <el-radio v-model="radio" :label="1">纯英文OCR</el-radio>
      <el-radio v-model="radio" :label="3">中英文OCR</el-radio>
      <div class="footer" style="text-align: right; margin-top: 20px">
        <el-button type="primary" @click="ocrConfigClose" class="el-button--cancel">取消</el-button>
        <el-button type="primary" @click="confirmOcrDialog()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

  export default {
    name: "headers",
    props: {},
    data() {
      return {
        username: localStorage.getItem("BAILIAN-SHIBIE-NICKNAME"),
        configVisible: false,
        ocrVisible: false,
        docTypes: Object,
        filedData: [],
        tableLeftLoading: false,
        tableRightLoading: false,
        postData: [],
        clickObj: null,
        radio: "",
        isVip: localStorage.getItem("enterpriseType") == "1",
      };
    },
    computed: {
      ...mapGetters(["roleState", "userType"]),
    },
    components: {},
    mounted() {
      //console.log(this.roleState, 'roleState');
      //console.log(this.userType, 'userType');
      setTimeout(() => {
        this.username = localStorage.getItem("BAILIAN-SHIBIE-NICKNAME");
      }, 500);
    },
    destroyed() { },
    methods: {
      goHome() {
        this.$router.push({
          path: '/'
        });
      },
      toUser() {
        this.$router.replace('/dashboard/userHome');
      },
      logout() {
        // 从官网登陆过来增加token
        let token = this.$route.query.token;

        if (token) {
          window.open("http://www.bailian-ai.com/demo.html", "_self");
          return;
        }
        this.$axios({
          url: this.$resource.userLogout,
          method: "get",
        }).then((res) => {
          // console.log(res)
          let code = res.data.data.code;
          if (code === "10005") {
            //退出成功
            localStorage.removeItem("BAILIAN-SHIBIE-USERNAME");
            localStorage.removeItem("BAILIAN-SHIBIE-NICKNAME");
            localStorage.removeItem("BAILIAN-SHIBIE-TOKEN");

            // 清除官网token
            localStorage.removeItem("BAILIAN-SHIBIE-OFFICEWEBSITE-TOKEN");
            localStorage.removeItem("orgCode");

            this.$router.push({
              name: "login",
            });
          }
        });
      },
      getListAllCertiType() {
        this.tableLeftLoading = true;
        let url = this.$resource.listDityExportFieldsConfig;
        this.$axios({
          url: url,
          method: "get",
        })
          .then((res) => {
            this.docTypes = res.data.data.exportFieldsConfigMap;
            this.tableLeftLoading = false;
          })
          .catch((e) => {
            this.tableLeftLoading = false;
          });
      },
      async getRightData(v) {
        this.filedData = [];
        for (let item in this.docTypes) {
          //console.log(item, 111);
          if (item === v) {
            this.filedData = this.docTypes[item];
            return this.actionFn(this.docTypes[item]);
          }
        }
      },
      actionFn(arr) {
        if (arr.length > 0) {
          arr.forEach((e) => {
            this.$nextTick(() => {
              this.$refs.dataTable.toggleRowSelection(
                e,
                e.usedFlag === 1 ? true : false
              );
            });
          });
        }
      },
      toggleSelection(row) {
        if (row.usedFlag === 1) {
          row.usedFlag = 0;
        } else {
          row.usedFlag = 1;
        }
        if (this.postData.length > 0) {
          this.filterFn(row);
        } else {
          this.postData.push(row);
        }
      },
      selectFn(row) {
        if (row.usedFlag === 1) {
          row.usedFlag = 0;
        } else {
          row.usedFlag = 1;
        }
        if (this.postData.length > 0) {
          this.filterFn(row);
        } else {
          this.postData.push(row);
        }
      },
      tableClick(row, v, s) {
        this.clickObj = Object.assign({}, row);
        this.getRightData(row);
      },
      filterFn(row) {
        this.postData.forEach((e, i) => {
          if (
            e.categoryName === row.categoryName &&
            e.dityName === row.dityName
          ) {
            this.postData.splice(i, 1);
          }
        });
        this.postData.push(row);
        //console.log(this.postData, "postData");
      },
      exportConfig() {
        this.configVisible = true;
        this.filedData = [];
        this.getListAllCertiType();
      },
      ocrConfig() {
        this.ocrVisible = true;
        this.getOcrType();
      },
      confirmOcrDialog() {
        //console.log(this.radio, 1);
        let url = this.$resource.updateUserOcrType.replace("{type}", this.radio);
        this.$axios({
          url: url,
          method: "get",
        }).then((res) => {
          this.$message.success("更新成功！");
          this.ocrConfigClose();
        });
      },
      configClose() {
        this.configVisible = false;
      },
      ocrConfigClose() {
        this.ocrVisible = false;
      },
      confirmDialog() {
        let url = this.$resource.setDityExportFieldsConfig;
        this.$axios({
          url: url,
          method: "post",
          data: this.postData,
        }).then((res) => {
          this.$message.success("保存成功！");
          this.postData = [];
        });
      },
      selectAll(v) {
        if (this.filedData.length > 0) {
          this.filedData.forEach((e) => {
            this.$set(e, "usedFlag", v === "all" ? 1 : 0);
            this.filterFn(e);
          });
        }
      },
      getOcrType() {
        let url = this.$resource.getUserOcrType;
        this.$axios({
          url: url,
          method: "get",
        })
          .then((res) => {
            this.radio = res.data.data;
          })
          .catch((e) => { });
      },
      openFn() {
        window.open('https://inspection.cloud-sh.com/zsWeb/#/login2', '_target')
      }
    },
  };
</script>
<style scoped>
  @import "./header.css";

  #header.config-fadeIn {
    animation: 0.2s;
    animation-fill-mode: forwards;

    .title {
      margin-left: 168px;
    }
  }

  #header .title .nav ul li.dropdown i[data-v-ed558de2] {
    margin-right: 5px !important;
  }

  #header.config-fadeOut {
    animation: 0.2s;
    animation-fill-mode: forwards;

    .title {
      margin-left: 0;
    }
  }

  .filed-config {
    .el-dialog__body {
      padding: 10px 20px;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
      background-color: #fff290 !important;
    }

    .el-table__body tr.current-row>td {
      background-color: #fff290;
    }
  }

  .ocr-sty {
    .el-dialog {
      position: relative;
      top: 30%;
    }
  }
</style>
<style lang="sass" scoped>
  @import './header.sass';
</style>